import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild, ContentChildren, DoCheck,
  ElementRef, EmbeddedViewRef,
  HostBinding,
  HostListener,
  Inject,
  InjectionToken,
  Input, IterableChangeRecord, IterableChanges, IterableDiffer, IterableDiffers, OnDestroy,
  OnInit,
  Optional,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {JdDyForm} from './dy-form';
import {FormFocusDirective} from './form-focus.directive';
import {isArray, isObject, isString, merge, isNumber, isFunction} from 'lodash';
import {AbstractControl, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {animate, style, transition, trigger} from '@angular/animations';
import {debounceTime, distinctUntilChanged, map, takeUntil} from 'rxjs/operators';
import {FocusKeyManager} from '@angular/cdk/a11y';
import {ENTER, TAB, UP_ARROW} from '@angular/cdk/keycodes';
import {
  Breakpoint,
  ColumnObj,
  DyFormDefaultConfig, JdDyFormAllowInputByChange,
  JdDyFormOptionColumn,
  JdDyFormOptionItem,
  JdDyFormSubmitOrRest,
} from './dy-form.interface';
import {
  checkConfig,
  DY_CONFIG,
  extraConfig,
  inFoConfig,
  inputConfig,
  pickerConfig,
  radioConfig,
  selectConfig,
  showTypeConfig,
  suffixActionConfig,
  tableSelectConfig
} from './dy-form-config';
import {CustomControlContext, CustomControlDirective} from './custom-control.directive';
import {CustomControlOutletDirective} from './custom-control-outlet.directive';
import {CUSTOM_HELP_MAP, getFormVaildError, getPlaceHolder, keyCode} from './dy-form-util';
import {CustomLabelContext, CustomLabelDirective} from './custom-label.directive';
import {CustomLabelOutletDirective} from './custom-label-outlet.directive';

export const DY_FORM_DEFAULT_CONFIG = new InjectionToken('DY_FORM_DEFAULT_CONFIG');

@Component({
  selector: 'jd-dy-form',
  templateUrl: './dy-form.component.html',
  styleUrls: ['./dy-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeIn', [
      transition('void => *', [
        style({opacity: 0}),
        animate(600, style({opacity: 1}))
      ]),
      transition('* => void', [animate(0, style({opacity: 0}))])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JdDyFormComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy, DoCheck {
  @HostBinding('@fadeIn') a = '';
  // æ¯å¦å·²ç»åå§åäº!
  private _isOnInit = false;

  private _unsubscribe$ = new Subject();
  private _dyConfig: DyFormDefaultConfig = {};
  formArea: FormGroup;

  formGroupDyForm: { [key: string]: JdDyForm } = {};

  private _cacheSetValues: { [key: string]: string } = {};

  private _controlItemAtt: string[] = [];

  private buttonMarginRight$ = new Subject<number>();

  @Input() size: 'large' | 'default' | 'small' = 'default';
  // å¨æè¡¨åéç½®
  private _formOptions: JdDyFormOptionItem[] = [];

  private _formOptionsDiffer: IterableDiffer<JdDyFormOptionItem> | null = null;

  private _customItemDiffer: IterableDiffer<JdDyFormOptionItem> | null = null;

  private _customChange$ = new Subject<IterableChanges<JdDyFormOptionItem>>();

  private _formOptionsDirty = true;

  private _resizeEvent: Function;

  private _dyForm: JdDyForm;

  private _invalidItem: JdDyFormOptionItem[] = [];

  private _customItem: JdDyFormOptionItem[] = [];

  controlArray: JdDyFormOptionItem[] = [];

  isLoading: { [key: string]: boolean } = {};

  readonly controlMap: Map<string, JdDyFormOptionItem> = new Map<string,
    JdDyFormOptionItem>();

  @ContentChild('suffix_button') suffix_button: TemplateRef<any>;
  @ContentChild('prefix_button') prefix_button: TemplateRef<any>;

  @ContentChildren(CustomControlDirective) private _customControl: QueryList<CustomControlDirective>;
  @ContentChildren(CustomLabelDirective) private _customLabel: QueryList<CustomLabelDirective>;

  @ViewChildren(CustomControlOutletDirective) private _customControlOutlet: QueryList<CustomControlOutletDirective>;
  @ViewChildren(CustomLabelOutletDirective) private _customLabelOutlet: QueryList<CustomLabelOutletDirective>;

  private get _customControls(): CustomControlDirective[] {
    return this._customControl ? this._customControl.toArray() : [];
  }

  private get _customLabels(): CustomLabelDirective[] {
    return this._customLabel ? this._customLabel.toArray() : [];
  }

  private get _customControlOutlets(): CustomControlOutletDirective[] {
    return this._customControlOutlet ? this._customControlOutlet.toArray() : [];
  }

  private get _customLabelOutlets(): CustomLabelOutletDirective[] {
    return this._customLabelOutlet ? this._customLabelOutlet.toArray() : [];
  }

  @ViewChild('label', {read: ElementRef}) labelElement: ElementRef;
  @Input() column = null;
  @Input() isInline = false;
  @Input() isGroup = false;

  @Input() loading = false;
  // loading æè¿°
  @Input() loadingTip = 'å è½½ä¸­...';
  buttonMarginRight: number;
  breakpointOptions: Breakpoint = {xs: 24, sm: 12, md: 12, lg: 8, xl: 6, xxl: 6};
  @Input() controlBreakpointOptions: ColumnObj = {
    label: {xs: 6, sm: 8, md: 6, lg: 10, xl: 8, xxl: 8},
    control: {xs: 18, sm: 16, md: 18, lg: 14, xl: 16, xxl: 16}
  };
  private readonly _columnDefaultConfig: JdDyFormOptionColumn = {
    sm: null,
    xs: null,
    md: null,
    lg: null,
    xl: null,
    xxl: null,
    label: {
      sm: null,
      xs: null,
      md: null,
      lg: null,
      xl: null,
      xxl: null
    },
    value: {
      sm: null,
      xs: null,
      md: null,
      lg: null,
      xl: null,
      xxl: null
    }
  };
  keyManager: FocusKeyManager<FormFocusDirective>;
  @ViewChildren(FormFocusDirective) surveyInputs: QueryList<FormFocusDirective>;

  submitButton: JdDyFormSubmitOrRest = {
    color: 'primary',
    text: 'æ äº¤',
    isShow: true
  };

  restButton: JdDyFormSubmitOrRest = {
    color: 'warn',
    text: 'é ç½®',
    isShow: true
  };
  @Input() isShowButton = true;

  @Input() isByDepWidthDoResponsive = false;
  // æ¯å¦åç´
  @Input() isVertical = false;

  getFormError = getFormVaildError;

  set formOptions(value: JdDyFormOptionItem[]) {
    this._formOptions = value;
  }

  get formOptions(): JdDyFormOptionItem[] {
    return this._formOptions;
  }

  @Input()
  set dyForm(value: JdDyForm) {
    this._dyForm = value;
    this.watchDyHelp();
  }

  get dyForm() {
    return this._dyForm;
  }

  /**
   * åè½¦äºä»¶
   */
  _ENTER(key: string, event: KeyboardEvent) {
    this._dyForm.OnEnter$.next({key, event});
  }

  @HostListener('keydown', ['$event'])
  _onKeyDown($event: KeyboardEvent) {
    const _keyCode = keyCode($event);
    if (_keyCode === UP_ARROW || ($event.shiftKey && _keyCode === TAB)) {
      if (_keyCode === TAB) {
        $event.preventDefault();
        this.keyManager.setPreviousItemActive();
      } else {
        if ($event.target['JD-SELECT'] && $event.target['JD-SELECT-OPEN']) {// JD-SELECT-OPEN
          return;
        } else {
          // this.keyManager.setPreviousItemActive();
        }
      }
    } else if (_keyCode === ENTER) {
      if ($event.target['JD-SELECT'] ||
        $event.target['NZ-DATE-PICKER'] ||
        $event.target['NZ-RANGE-PICKER']) {
        return;
      } else {
        // this.keyManager.setNextItemActive();
      }
      // æäº¤
    } else if ($event.shiftKey && _keyCode === 83) {
      this.submit(this.formArea);
      // éç½®
    } else if ($event.shiftKey && _keyCode === 82) {
      this.rest();
    }
  }

  openChange(isOpen: boolean, name: string) {
    this._dyForm.OpenChange$.next({
      isOpen,
      key: name,
      isNeedLoading: isOpen && !this._dyForm.selectContentIsExit(name)
    });
  }

  _clickSuffixAction(name: string, $event) {
    this._dyForm.OnSuffixAction$.next({
      name, $event
    });
  }

  watchDyHelp() {
    this._setFormKey(this._dyForm.initState);
    this._dyForm.formFieldChange$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(value => {
        if (!value) {
          return;
        }
        // åå§å
        if (
          value &&
          value.formOptions &&
          isArray(value.formOptions)
        ) {
          this.formOptions = value.formOptions;
          this._clear();
          // this.initControlArray();
        }
        // æ´æ°å­æ®µ
        if (
          value &&
          value.update &&
          isArray(value.update) &&
          value.update.length
        ) {
          this.updateOptions(...value.update);
        }
        // ç§»é¤å­æ®µ
        if (value && value.remove) {
          this.removeOptions(value.remove);
        }
        // å¢å å­æ®µ
        if (value && value.add && isArray(value.add) && value.add.length) {
          this.addOptions(null, ...value.add);
        }

        if (value.markValid) {
          this._markValid();
          this.cd.markForCheck();
        }

        if (value.isLoading) {
          this.isLoading = value.isLoading;
          this.cd.markForCheck();
        }
      });
    this._dyForm.setFormValue$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(value => {
        if (value && isObject(value)) {
          this.controlArray.length && this.formArea
            ? this.setValue(value)
            : (this._cacheSetValues = value);
        }
      });
    this._dyForm.formKeyChange$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(value => this._setFormKey(value));
  }

  private _setFormKey(value: JdDyFormAllowInputByChange) {
    if (!value) {
      return;
    }
    let _isChange = false;
    for (const key in value) {
      if (isObject(value[key]) && !isArray(value[key])) {
        this[key] = this[key] === null ? {} : this[key];
        Object.assign(this[key], value[key]);
      } else {
        this[key] = value[key];
      }
      _isChange = true;
    }
    if (_isChange) {
      this.cd.markForCheck();
    }
  }

  _markValid() {
    for (const controlsKey in this.formArea.controls) {
      this.formArea.controls[controlsKey].markAsDirty();
      this.formArea.controls[controlsKey].markAsTouched();
      this.formArea.controls[controlsKey].updateValueAndValidity();
    }
  }

  _inputBlur(name: string) {
    this._dyForm.OnInputBlur$.next(name);
  }

  private _clear() {
    this.controlArray = [];
    this.controlMap.clear();
    this._controlItemAtt = [];
    this.removeAll();
  }

  addField(fi: JdDyFormOptionItem, keyOrIndex?: string | number) {
    if (!this._isExist(fi.name)) {
      const _column = {
        xs: 24, sm: 24, md: 24, lg: 16, xl: 12, xxl: 12,
        label: {xs: 6, sm: 4, md: 3, lg: 5, xl: 4, xxl: 4},
        value: {xs: 18, sm: 20, md: 21, lg: 19, xl: 20, xxl: 20}
      };

      const _vColumn = {
        label: {xs: 6, sm: 4, md: 3, lg: 5, xl: 4, xxl: 4},
        value: {xs: 18, sm: 20, md: 21, lg: 19, xl: 20, xxl: 20}
      };
      const column = fi.column
        ? merge({}, this._columnDefaultConfig, fi.column)
        : fi.type === 'group' && !this.isVertical
          ? merge({}, this._columnDefaultConfig, _column)
          : this.isVertical ? merge({}, this._columnDefaultConfig, _vColumn)
            : this._columnDefaultConfig;
      const control: JdDyFormOptionItem = {
        name: fi.name,
        label: fi.label,
        defaultValue: fi.defaultValue,
        type: fi.type ? fi.type : 'input',
        inputWidth: fi.inputWidth,
        disabled: fi.disabled,
        placeHolder: fi.placeHolder,
        isMust: fi.isMust,
        hide: fi.hide,
        column: column,
        labelColor: fi.labelColor,
        inputType: !fi.inputType ? 'text' : fi.inputType,
        isCustomizeAfter: fi.isCustomizeAfter,
        inputConfig: inputConfig(this._dyConfig.inputConfig, fi.inputConfig),
        infoConfig: inFoConfig(this._dyConfig.infoConfig, fi.infoConfig),
        extraConfig: extraConfig(this._dyConfig.extraConfig, fi.extraConfig),
        showType: showTypeConfig(this._dyConfig.showType, fi.showType),
        suffixAction: suffixActionConfig(this._dyConfig.suffixAction, fi.suffixAction),
        selectConfig: selectConfig(this._dyConfig.selectConfig, fi.selectConfig),
        pickerConfig: pickerConfig(this._dyConfig.pickerConfig, fi.pickerConfig),
        radioConfig: radioConfig(this._dyConfig.radioConfig, fi.radioConfig),
        tableSelectConfig: tableSelectConfig(this._dyConfig.tableSelectConfig, fi.tableSelectConfig),
        checkConfig: checkConfig(this._dyConfig.checkConfig, fi.checkConfig),
        formGroup: fi.formGroup ? fi.formGroup : [],
        validators: fi.validators ? fi.validators : [],
        asyncValidators: fi.asyncValidators ? fi.asyncValidators : [],
        invalid: !!fi.invalid,
        validOfIf: fi.validOfIf ? fi.validOfIf : null,
        customLabel: !!fi.customLabel,
        groupCol: fi.groupCol ? fi.groupCol : 0
      };
      control.placeHolder = getPlaceHolder(control);
      this.controlMap.set(control.name, control);
      let __index = this._getIndexByName(keyOrIndex, this.controlArray);
      if (__index > -1) {
        this.controlArray.splice(__index, 0, control);
      } else {
        this.controlArray.push(control);
      }
      this._controlItemAtt.push(control.name);
      /*if (control.type === "custom") {
        this._customItem.push(control);
      }*/
      this.formArea.addControl(
        control.name,
        new FormControl(
          control.defaultValue !== null ? control.defaultValue : null,
          fi.validators ? fi.validators : [],
          fi.asyncValidators ? fi.asyncValidators : []
        )
      );
    } else if (fi) {
      const oldControl = this.controlMap.get(fi.name),
        index = this.controlArray.findIndex(value => value.name === fi.name);
      oldControl.selectConfig.content = [];

      merge(oldControl, fi);

      this.controlArray.splice(index, 1, oldControl);
      this.controlMap.delete(fi.name);
      this.controlMap.set(fi.name, oldControl);

      const __invalidIndex = this._invalidItem.findIndex(value => value.name === fi.name);
      if (__invalidIndex > -1 && !fi.validOfIf) {
        this._invalidItem.splice(__invalidIndex, 1);
      }
      // TODO å¯¹äº å¨æéªè¯ æä¸æ¯æ!
      /*this.formArea.setControl(
        fi.name,
        new FormControl(
          this.getFormControl(fi.name).value,
          oldControl.validators ? oldControl.validators : [],
          oldControl.asyncValidators ? oldControl.asyncValidators : []
        )
      );*/
    }
  }

  private _updateCustomItem() {
    this._customItem = [];
    this.controlArray.forEach(value => {
      if (value.type === 'custom' || value.customLabel) {
        this._customItem.push(value);
      }
    });
  }

  removeField(nameOrIndex: string | number, isDelInvalid = true): void {
    this.controlArray = this.controlArray.filter((value, index) => {
      if (value.name === nameOrIndex || index === nameOrIndex) {
        this._controlItemAtt.splice(index, 1);
        this.formArea.removeControl(value.name);
        this.controlMap.delete(value.name);
        if (isDelInvalid && value.validOfIf) {
          this._invalidItem.splice(this._invalidItem.findIndex(value1 => value1.name === value.name), 1);
        }
        return false;
      }
      return true;
    });
  }

  OnNotSearchResult($event: { isNeedLoading: boolean, value: string }, name): void {
    if (this._dyForm) {
      this._dyForm.OnNotSearchResult$.next({name, isNeedLoading: $event.isNeedLoading, value: $event.value});
    }
  }

  removeAll() {
    this.controlArray = this.controlArray.filter(() => {
      // this._controlItemAtt.splice(index, 1);
      this.formArea.removeControl(name);
      // this.controlMap.delete(name);
      return false;
    });
    this.controlMap.clear();
    this._controlItemAtt = [];
    this._invalidItem = [];
  }

  /**
   * è¡¨åéç½®
   * @param $event
   */
  rest($event?: MouseEvent): void {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    this._dyForm.OnRest$.next(this.formArea);
  }

  /**
   * è¡¨åæäº¤
   * @param formArea
   * @param $event
   */
  submit(formArea: FormGroup, $event?: KeyboardEvent): void {
    this._dyForm.OnSubmit$.next(formArea);
  }

  _tableSelectChange($event) {
    this._dyForm.OnTableSelectChange$.next($event);
  }

  getFormControl(name: string): AbstractControl {
    return this.formArea.controls[name];
  }

  private _validSetValues(value?: object): boolean {
    if (isObject(value) && !isArray(value)) {
      const keys = Object.keys(value);
      return keys.length
        ? keys.some(value1 => this._controlItemAtt.indexOf(value1) !== -1)
        : false;
    } else {
      console.error(`Parameter error: @Input [setValues] must be an array`);
      return false;
    }
  }

  /**
   * è®¾ç½®å¼
   * @param value
   */
  setValue(value?: { [p: string]: any }): void {
    if (this._validSetValues(value)) {
      this.formArea.patchValue(value);
      if (this._dyForm && this._dyForm.isAutoFillSelectContent) {
        this._autoFillSelectContent(value);
      }
      this.cd.markForCheck();
    }
  }

  reset(value?: any, options?: {
    onlySelf?: boolean;
    emitEvent?: boolean;
  }) {
    this.formArea.reset(value, options);
    this.cd.markForCheck();
  }

  _autoFillSelectContent(value: { [p: string]: any }) {
    const _contents: JdDyFormOptionItem[] = [];
    for (let controlArrayItem of this.controlArray) {
      if (controlArrayItem.type === 'select') {
        _contents.push(controlArrayItem);
      }
    }

    for (let content of _contents) {
      const __content = content.selectConfig.content;
      let _labelName: any = content.selectConfig.labelName;

      if (!value[content.name]) {
        continue;
      }
      // å¦æå·²ç»å­å¨content

      _labelName = _labelName ? _labelName : content.name + '_name';

      const _labelValue = value[_labelName] ? value[_labelName] : value[content.name];
      if (__content.length) {
        // å¦æå­å¨ è¯´æä¸éè¦å¡«å
        if (!__content.some(value1 => value1.value === value[content.name])) {
          __content.push({value: value[content.name], preMark: true, label: _labelValue});
        }
      } else {
        __content.push({value: value[content.name], preMark: true, label: _labelValue});
      }
    }
  }


  private _isExist(name: string) {
    return this.controlArray.some(value => value.name === name);
  }

  _onSearch($event, key) {
    this._dyForm.OnSearch$.next({[key]: $event});
  }

  constructor(private fb: FormBuilder,
              private cd: ChangeDetectorRef,
              @Optional() @Inject(DY_FORM_DEFAULT_CONFIG) private _config,
              private renderer: Renderer2,
              private _differs: IterableDiffers) {
    // åå¹¶é»è®¤éç½®
    if (this._config) {
      merge(this._dyConfig, DY_CONFIG, this._config);
    } else {
      merge(this._dyConfig, DY_CONFIG);
    }
    this.formArea = this.fb.group({});
    this.watchFormChange();
    this._resizeEvent = this.renderer.listen('window', 'resize', () => {
      if (
        !this.isInline &&
        !this.isVertical &&
        this.labelElement &&
        this.controlArray.length &&
        this.labelElement.nativeElement &&
        this.labelElement.nativeElement.offsetWidth
      ) {
        this.buttonMarginRight$.next(
          this.labelElement.nativeElement.offsetWidth
        );
      }
    });
  }


  /**
   * åå§åèªå®ä¹æ§ä»¶  éç¨
   * @param type èªå®ä¹ç±»å 'label' | 'control'
   */
  private _initCustom(type: 'label' | 'control') {
    const _controlNames = [],
      _customItem = this._customItem,
      _customItemMap: { [key: string]: JdDyFormOptionItem } = {},
      _helpMap = CUSTOM_HELP_MAP;
    _customItem.forEach(value => {
      if ((type === 'label' && value.customLabel) || (type === 'control' && value.type === 'custom')) {
        _customItemMap[value.name] = value;
      }
    });

    (this[_helpMap[type].customRefs] as any[])
      .forEach((value, index) => {
        const controlName = value[_helpMap[type].controlName];
        if (controlName) {
          if (_controlNames.includes(controlName)) {
            console.warn(`æ§ä»¶åç§° ${controlName} å·²ç»å­å¨  å°è¢«å¿½ç¥!`);
          } else {
            _controlNames.push(controlName);
          }
        } else {
          if (_customItem && _customItem[index]) {
            value[_helpMap[type].controlName] = _customItem[index].name;
          } else {
            console.warn(`å­å¨ å¤ä½ç ${_helpMap[type].directiveName} æä»¤  å©ä½æªå¹éä¸ç  å°è¢«å¿½ç¥`);
          }
        }
      });
  }

  /**
   * åå§åèªå®ä¹æ§ä»¶label
   */
  private _initCustomLabel() {
    if (this._customLabels.length) {
      this._initCustom('label');
    }
  }

  /**
   * åå§åèªå®ä¹æ§ä»¶control
   */
  private _initCustomControl() {
    if (this._customControls.length) {
      this._initCustom('control');
    }
  }

  /**
   * è·åèªå®ä¹æ¨¡æ¿çéç¨æ¹æ³
   * @param type èªå®ä¹ç±»å  'label' | 'control'
   * @param key æ§ä»¶åç§° æ ¹æ®æ§ä»¶åç§°è·åå¯¹åºçèªå®ä¹æ¨¡æ¿
   * @return è¿åå¯¹åºçæ¨¡æ¿ æè undefined
   */
  private _getCustomTemp<T>(type: 'label' | 'control', key: string): TemplateRef<T> | undefined {
    for (let control of this[CUSTOM_HELP_MAP[type].customRefs]) {
      if (control[CUSTOM_HELP_MAP[type].controlName] === key) {
        return control.templateRef;
      }
    }
  }

  /**
   * è·åèªå®ä¹labelæ¨¡æ¿
   * @param key æ§ä»¶åç§°
   * @return è¿åå¯¹åºçæ¨¡æ¿ æè undefined
   */
  private _getCustomLabelTemp(key: string): TemplateRef<CustomLabelContext> | undefined {
    if (this._customLabels.length) {
      return this._getCustomTemp<CustomLabelContext>('label', key);
    }
  }

  /**
   * è·åèªå®ä¹æ§ä»¶æ¨¡æ¿
   * @param key æ§ä»¶åç§°
   * @return è¿åå¯¹åºçæ¨¡æ¿ æè undefined
   */
  private _getCustomControlTemp(key: string): TemplateRef<CustomControlContext> | undefined {
    if (this._customControls.length) {
      return this._getCustomTemp<CustomControlContext>('control', key);
    }
  }

  private _perViewChange(
    view: EmbeddedViewRef<CustomControlContext>, record: IterableChangeRecord<JdDyFormOptionItem>) {
    const _$implicit = this.formArea.get(record.item.name);
    view.context.config = record.item;
    if (view.context.$implicit !== _$implicit) {
      view.context.$implicit = _$implicit as FormControl;
    }
  }

  private _perLabelViewChange(
    view: EmbeddedViewRef<CustomLabelContext>, record: IterableChangeRecord<JdDyFormOptionItem>) {
    view.context.$implicit = record.item;
  }

  private _renderCustom(type: 'label' | 'control', value: IterableChangeRecord<JdDyFormOptionItem>) {
    const insertTuples: CustomControlRecordViewTuple[] = [],
      insetLabelTuples: CustomLabelRecordViewTuple[] = [];
    this[CUSTOM_HELP_MAP[type].outlet].forEach(value1 => {
      const controlName = value1[CUSTOM_HELP_MAP[type].outletName];
      let context;
      if (value.item.name === controlName) {
        let _temp: TemplateRef<any>;
        if (type === 'label') {
          context = new CustomLabelContext(null);
          _temp = this._getCustomLabelTemp(controlName);
        } else if (type === 'control') {
          context = new CustomControlContext(null, null);
          _temp = this._getCustomControlTemp(controlName);
        }
        if (_temp) {
          let view: EmbeddedViewRef<any>;
          if (value1.viewContainerRef.length) {
            view = value1.viewContainerRef.get(0);
          } else {
            view = value1.viewContainerRef
              .createEmbeddedView(_temp, context);
          }
          // è®°å½è§å¾
          if (type === 'label') {
            insetLabelTuples.push(new CustomLabelRecordViewTuple(value, view));
          } else if (type === 'control') {
            insertTuples.push(new CustomControlRecordViewTuple(value, view));
          }
        } else {
          throw Error(`æ¾ä¸å° æ¥æ æ§ä»¶åä¸º ${value} ç ${CUSTOM_HELP_MAP[type].directiveName} æä»¤  æ¨å¯ä»¥è¿æ ·å£°æ
                ${CUSTOM_HELP_MAP[type].errorInfoTemp.replace('$value', value.item.name)}`);
        }
      }
    });
    // å¡«åä¸ä¸æ
    for (let i = 0; i < insertTuples.length; i++) {
      this._perViewChange(insertTuples[i].view, insertTuples[i].record);
    }
    for (let i = 0; i < insetLabelTuples.length; i++) {
      this._perLabelViewChange(insetLabelTuples[i].view, insetLabelTuples[i].record);
    }
  }

  renderCustomLabel(value: IterableChangeRecord<JdDyFormOptionItem>) {
    if (this._customLabelOutlets.length) {
      this._renderCustom('label', value);
    }
  }

  renderCustomControl(value: IterableChangeRecord<JdDyFormOptionItem>) {
    if (this._customControlOutlets.length) {
      this._renderCustom('control', value);
    }
  }

  ngAfterContentInit() {

    this._initCustomControl();
    this._initCustomLabel();
    this._customChange$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(value => {
        this._applyCustomChanges(value);
      });

    this._customControl.changes
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => this._initCustomControl());

    this._customLabel.changes
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => this._initCustomLabel());
  }

  ngOnInit() {

    // this.initControlArray();
  }

  ngAfterViewInit(): void {
    this._dyForm.formToApiHelp$.next({formGroup: this.formArea});
    this._dyForm.formToApiHelp$.next({formComponent: this});
    setTimeout(() => {
      if (!this.isInline && this.controlArray.length && this.labelElement && this.labelElement.nativeElement) {
        this.buttonMarginRight$.next(
          this.labelElement.nativeElement.offsetWidth
        );
      }
    }, 80);
    this.buttonMarginRight$
      .pipe(
        debounceTime(20),
        distinctUntilChanged()
      )
      .subscribe(value => {
        if (!this.isInline) {
          this.buttonMarginRight = value;
          !this.cd['destroyed'] &&
          this.cd.detectChanges();
        }
      });
    this.keyManager = new FocusKeyManager(this.surveyInputs).withWrap();
  }

  watchFormChange(): void {
    this.formArea.valueChanges
      .pipe(
        takeUntil(this._unsubscribe$),
        debounceTime(200),
        distinctUntilChanged(
          (x, y) => {
            return JSON.stringify(x) === JSON.stringify(y);
          },
          x => {
            return x;
          }
        ),
        map(value => {
          this._invalidItem.forEach(value1 => {
            if (value1.validOfIf && isFunction(value1.validOfIf)) {
              // å¦ææ»¡è¶³æ¡ä»¶
              const __index = this.formOptions.findIndex(value2 => value2.name === value1.name);
              this.formOptions[__index].invalid = !value1.validOfIf(value);
            }
          });
          return value;
        })
      )
      .subscribe(value => this._dyForm.valueChanges$.next(value));
  }

  /**
   * éæ¾èµæº
   */
  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
    this._resizeEvent && this._resizeEvent();
  }

  ngDoCheck(): void {
    /*console.log(!this.isInline &&
      !this.isVertical &&
      this.labelElement &&
      this.controlArray.length &&
      this.labelElement.nativeElement &&
      this.labelElement.nativeElement.offsetWidth);*/

    if (this._formOptionsDirty) {
      this._formOptionsDirty = false;

      try {
        this._formOptionsDiffer = this._differs.find(this._formOptions).create(this.trackByFn);
        this._customItemDiffer = this._differs.find(this._customItem).create(this.trackByFn);
      } catch (e) {
        throw new Error(
          `Cannot find a differ supporting object '${this._formOptions}'
             of type '${getTypeNameForDebugging(this._formOptions)}'. formOptions only supports binding to Iterables such as Arrays.`);
      }
    }

    if (this._customItemDiffer) {
      const changes = this._customItemDiffer.diff(this._customItem);

      if (changes) {
        this._customChange$.next(changes);
      }
    }

    if (this._formOptionsDiffer) {
      const changes = this._formOptionsDiffer.diff(this._formOptions);

      if (changes) {
        this._applyChanges(changes);
        if (!this._isOnInit) {
          this._isOnInit = true;
          setTimeout(() => {
            if (this._dyForm && this._dyForm.OnInit$ && this._dyForm.OnInit$.next) {
              this._dyForm.OnInit$.next(this.formArea);
              this._dyForm.OnInit$.complete();
            }
          });
        }
      }
    }
  }

  private _applyCustomChanges(changes: IterableChanges<JdDyFormOptionItem>) {
    changes.forEachOperation((record: IterableChangeRecord<JdDyFormOptionItem>,
                              previousIndex: number | null,
                              currentIndex: number | null) => {
      if (record.previousIndex === null) {
        // console.log(record, 'å¢å ');
        if (record.item.type === 'custom') {
          this.renderCustomControl(record);
          // å¦æè¯¥æ§ä»¶è¿å­å¨èªå®ä¹label
          if (record.item.customLabel) {
            this.renderCustomLabel(record);
          }
        } else if (record.item.customLabel) {
          this.renderCustomLabel(record);
        }

      } else if (currentIndex === null) {
        // console.log(record, 'å é¤');
        // _applyChanges ä¼å¤ç
        // this._removeCustomControl(previousIndex);
      } else {
        // _applyChanges ä¼å¤ç
        // console.log(record, 'ç§»å¨');
      }
    });
    this.cd.markForCheck();
  }

  private _applyChanges(changes: IterableChanges<JdDyFormOptionItem>) {
    changes.forEachOperation((record: IterableChangeRecord<JdDyFormOptionItem>,
                              previousIndex: number | null,
                              currentIndex: number | null) => {
      // æ°å¢ || ä¿®æ¹
      if (record.previousIndex === null) {
        // å¦æè¯¥æ§ä»¶ææ
        const _invalidNames = [];
        this._invalidItem.forEach(value => _invalidNames.push(value.name));
        if (record.item.validOfIf && !_invalidNames.includes(record.item.name)) {
          this._invalidItem.push(record.item);
        }
        if (!record.item.invalid) {
          this.addField(record.item, currentIndex);
        } else {
          this.removeField(currentIndex, false);
        }
      } else if (currentIndex === null) {
        // å é¤
        if (!this.formOptions[previousIndex] || (this._getIndexByName(record.item.name) < 0)) {
          this.removeField(record.item.name);
        }
      } else {
        // å¦æä¸è¿°æ¡ä»¶åä¸æ»¡è¶³
        // åè¿è¡ç§»å¨æä½
        this.move(previousIndex, currentIndex);
      }
    });
    this._updateCustomItem();
    if (this._cacheSetValues) {
      this.setValue(this._cacheSetValues);
      this._cacheSetValues = null;
    }
    this.cd.markForCheck();
    // console.log(this._formOptions);
    changes.forEachIdentityChange(record => {
      console.log(record);
    });
  }

  removeOptions(keyOrIndex: string | number | string[] | number[]) {
    if (isArray(keyOrIndex)) {
      const keys: string[] = keyOrIndex as any;
      keys.forEach(value => {
        this.removeOptions(value);
      });
      return;
    }
    const index = this._getIndexByName(keyOrIndex);

    if (index > -1) {
      this._formOptions.splice(index, 1);
    }
  }

  private _getIndexByName(keyOrIndex?: string | number, item?: JdDyFormOptionItem[]): number {
    let index = -1;
    if (isString(keyOrIndex)) {
      index = (item ? item : this.formOptions).findIndex(value => value.name === keyOrIndex);
    } else if (isNumber(keyOrIndex)) {
      index = keyOrIndex;
    }
    return index;
  }

  updateOptions(...item: JdDyFormOptionItem[]) {
    const namesMap: { [key: string]: number } = {}, addFiled = [];
    item.forEach((value, index) => namesMap[value.name] = index);

    if (item.length) {
      this._formOptions.forEach(value => {
        const __index = namesMap[value.name];
        if (__index > -1) {
          merge(value, item[__index]);
          namesMap[value.name] = -1;
        }
      });

      for (let key in namesMap) {
        if (namesMap[key] > -1) {
          addFiled.push(item[namesMap[key]]);
        }
      }
      // å¦æå­å¨å¹éä¸ä¸çæ°æ®  åæ°å¢
      if (addFiled.length) {
        this.addOptions(null, ...addFiled);
      }
    }
  }

  addOptions(keyOrIndex?: string | number, ...item: JdDyFormOptionItem[]) {
    const addFiled = [];
    item.forEach(value => {
      if (this.controlMap.has(value.name)) {
        return;
      }
      if (this._getIndexByName(value.name) < 0) {
        addFiled.push(value);
      }
    });
    if (keyOrIndex === null && addFiled.length) {

      return this._formOptions.push(...addFiled);
    }
    const index = this._getIndexByName(keyOrIndex);

    if (index > -1 && addFiled.length) {
      this._formOptions.splice(index, 0, ...addFiled);
    }
  }

  move(previousIndex: number | null, currentIndex: number | null) {
    let temp = this.controlArray[currentIndex];
    this.controlArray[currentIndex] = this.controlArray[previousIndex];
    this.controlArray[previousIndex] = temp;
  }

  private trackByFn(index: number, item: JdDyFormOptionItem) {
    return JSON.stringify(item);
  }

}

export function getTypeNameForDebugging(type: any): string {
  return type['name'] || typeof type;
}


export class CustomControlRecordViewTuple {
  constructor(public record: IterableChangeRecord<JdDyFormOptionItem>, public view: EmbeddedViewRef<CustomControlContext>) {
  }
}

export class CustomLabelRecordViewTuple {
  constructor(public record: IterableChangeRecord<JdDyFormOptionItem>, public view: EmbeddedViewRef<CustomLabelContext>) {
  }
}
